type ResponseMessage = {
    type: 'reply';
    message: string;
    nextMessageId: number;
};

type ResponseIgnore = {
    type: 'ignore';
    nextMessageId: number;
};

export type ResponseOption = ResponseMessage | ResponseIgnore;

export type TextMessage = {
    type: 'received' | 'sent';
    message: string;
};

type MessageState = {
    id: number;
    message: string;
    // If no options are provided, the conversation will end
    options?: Array<ResponseOption>;
};

const JIMBO: Array<MessageState> = [
    {
        id: 0,
        message: 'So did you book that dentist appointment yet?',
        options: [
            {
                type: 'reply',
                message: "Yep it's in my calendar.",
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: "Not yet, I'll do it soon.",
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 0,
            },
        ],
    },
    {
        id: 1,
        message: 'Yay!',
    },
    {
        id: 2,
        message: 'Hurryyyyyy',
        options: [
            {
                type: 'reply',
                message: "Not yet, I'll do it soon.",
                nextMessageId: 2,
            },
            {
                type: 'reply',
                message: "Fine I'll do it now.",
                nextMessageId: 0,
            },
            {
                type: 'ignore',
                nextMessageId: 0,
            },
        ],
    },
];

const SQUALOR: Array<MessageState> = [
    {
        id: 0,
        message: 'Hey can I borrow $100?',
        options: [
            {
                type: 'reply',
                message: 'Yeah of course',
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'No, sorry',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 3,
            },
        ],
    },
    {
        id: 1,
        message: 'Thanks! And can I borrow $100 the day after that?',
        options: [
            {
                type: 'reply',
                message: 'Yeah of course',
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'No, sorry',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 3,
            },
        ],
    },
    {
        id: 2,
        message: "Please? I'll pay you back tomorrow.",
        options: [
            {
                type: 'reply',
                message: 'Yeah of course',
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'No, sorry',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 3,
            },
        ],
    },
    {
        id: 3,
        message: "Ugh I'll ask someone else",
    },
];

const DOLORES: Array<MessageState> = [
    {
        id: 0,
        message: "Let's rob a bank together!",
        options: [
            {
                type: 'reply',
                message: "I'd be honored",
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: "I'd rather not",
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 3,
            },
        ],
    },
    {
        id: 1,
        message: 'You really sure?',
        options: [
            {
                type: 'reply',
                message: "I'm sure",
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'Actually maybe not',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 1,
            },
        ],
    },
    {
        id: 2,
        message: "That's fine, we can do something else",
    },
    {
        id: 3,
        message: 'You. Me. Bank robbery 👀',
        options: [
            {
                type: 'reply',
                message: "I'd be honored",
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: "I'd rather not",
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 3,
            },
        ],
    },
];

const RAMONA: Array<MessageState> = [
    {
        id: 0,
        message: 'Wanna run a marathon with me tomorrow? 🤠',
        options: [
            {
                type: 'reply',
                message: 'Sure',
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'No thanks',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 0,
            },
        ],
    },
    {
        id: 1,
        message: 'Awesome! See you at 6am!',
    },
    {
        id: 2,
        message: "But you'll be so fit! 🥺",
        options: [
            {
                type: 'reply',
                message: 'Sure',
                nextMessageId: 1,
            },
            {
                type: 'reply',
                message: 'No thanks',
                nextMessageId: 2,
            },
            {
                type: 'ignore',
                nextMessageId: 0,
            },
        ],
    },
];

export const CONTACTS = ['Jimbo', 'Squalor', 'Dolores', 'Ramona'] as const;

export type Contact = (typeof CONTACTS)[number];

export const CONVERSATION_STATE_MACHINES: Record<
    Contact,
    Array<MessageState>
> = {
    Jimbo: JIMBO,
    Squalor: SQUALOR,
    Dolores: DOLORES,
    Ramona: RAMONA,
};
